import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, ButtonGroup, Card, Col, Container, Form, Modal, Overlay, Row, Tooltip, } from "react-bootstrap";
import { getUserInfo, updateUser } from "../services/UserService";
import { Redirect } from "react-router-dom";
import { NavbarBrand } from 'react-bootstrap';

export default function Accountdetails({ match }) {

    const [user, setUser] = useState({});
    const [readOnly, setReadOnly] = useState(true);

    const [newFirstName, setNewFirstName] = useState();
    const [newLastName, setNewLastName] = useState();

    const [toDashboard, setToDashboard] = useState(false)
    const [error, setError] = React.useState(false);
    const [errorText, setErrorText] = React.useState("");

    const [showDeleteUserPopover, setShowDeleteUserPopover] = useState(false);
    const target = useRef(null);


    const [show, setShow] = useState(false);
    const [showDelete, setShowDelete] = useState(false);


    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    const handleCloseDelete = () => setShowDelete(false);

    useEffect(() => {

        const getUser = async () => {
            setUser(await getUserInfo(match.params.id))

        }
        getUser().then(() => {

        });
    }, [])

    if (toDashboard === true) {
        return <Redirect to='/dashboard' />
    }


    const handleUpdateUser = () => {
        try {
            updateUser(match.params.id, newFirstName, newLastName).then(() => {
                setError(true);
                setErrorText("Användare uppdaterad");

                window.location.reload();
            });
        } catch (e) {
            alert(e)
        }
    }



    const dateFormatter = (value) => {
        if (value) {


            return value.toDate()
        }

    }
    const authFormatter = (value) => {
        switch (value) {
            case true:
                return "Webb";
            case false:
                return "App";

            default:
                return "Fel"
        }
    }



    return (
        <Container fluid>
            <NavbarBrand href="/users">

            </NavbarBrand>
            {error ? <Alert variant={"success"}>{errorText}</Alert> : null}
            <Row>
                <Col>
                    <Card>
                        <Form>
                            <Row>
                                <span style={{
                                    fontSize: 22,
                                    paddingRight: 20,
                                    color: "#5291CA"
                                }}>{user.firstName + " " + user.lastName}  </span>
                                <span>Redigera användare </span>
                                <div style={{ width: '16' }}>
                                    <Button onClick={() => setReadOnly(!readOnly)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            fill="currentColor"
                                            className="bi bi-pencil" viewBox="0 0 16 16">
                                            <path
                                                d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                                        </svg>
                                    </Button>
                                </div>
                            </Row>
                            <Row>
                                <Col>
                                    <span>Förnamn</span>
                                    <Form.Control readOnly={readOnly} placeholder="Förnamn"
                                        defaultValue={user.firstName}
                                        onChange={(event => setNewFirstName(event.target.value))} />
                                </Col>
                                <Col>
                                    <span>Efternamn</span>
                                    <Form.Control readOnly={readOnly} placeholder="Efternamn"
                                        defaultValue={user.lastName}
                                        onChange={(event => setNewLastName(event.target.value))} />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span>
                                        Företag
                                    </span>
                                    <Form.Control readOnly={true} placeholder="Företag"
                                        defaultValue={user.company}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span>
                                        Behörighet
                                    </span>
                                    <Form.Control as="select" disabled id="auth" placeholder="Välj behörighet"
                                        defaultValue={authFormatter(user.allowWeb)}
                                    >
                                        <option value="App">App</option>
                                        <option value="Webb">Webb</option>

                                    </Form.Control>


                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span>
                                        Ansluten sedan
                                    </span>
                                    <Form.Control readOnly={true} placeholder="Anslöts"
                                        defaultValue={dateFormatter(user.joined)}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <ButtonGroup>
                                        <Button variant="success" onClick={handleShow}>Spara ändringar</Button>


                                        <Button variant={"outline-danger"} ref={target}

                                            onClick={() => setShowDeleteUserPopover(!showDeleteUserPopover)}>
                                            Vill du bort en användare?
                                        </Button>
                                        <Overlay target={target.current} show={showDeleteUserPopover} placement="right">
                                            {(props) => (
                                                <Tooltip id="overlay-example" {...props}>
                                                    För att ta bort en användare, kontakta Leadtub
                                                </Tooltip>
                                            )}
                                        </Overlay>

                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </Col>
            </Row>

            <Modal show={showDelete} onHide={handleCloseDelete}>
                <Modal.Header closeButton>
                    <Modal.Title>Radera användare</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span>Vill du ta bort denna användare permanent?</span>
                    <br />
                    <strong>Detta går ej att ångra</strong>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="warning" >
                        Ta bort
                    </Button>
                    <Button variant="secondary" onClick={handleCloseDelete}>
                        Avbryt
                    </Button>

                </Modal.Footer>
            </Modal>

            {/*Spara ändringar Modal*/}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Bekräfta ändringar</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {newFirstName != null &&
                        <Row>
                            <span>Förnamn: {newFirstName}</span>
                        </Row>
                    }
                    {newLastName != null &&
                        <Row>
                            <span>Efternamn: {newLastName}</span>
                        </Row>
                    }




                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Avbryt
                    </Button>
                    <Button variant="primary" onClick={handleUpdateUser}>
                        Spara ändringar
                    </Button>
                </Modal.Footer>
            </Modal>

        </Container>
    )
}
